export const airAllergyMixin = {
  data() {
    return {
      airAllergens: [
        [
          "",
          "",
          "Cenchrus ciliaris",
          "Cynodon dactylon",
          "Imperata cylindrica",
          "Pennisetum typhoides",
          "Sorghum vulgaris",
          "Adhatoda vasica"
        ],
        [
          "Ageratum conyzoides",
          "Amaranthus spinosus",
          "Argemone mexicana",
          "Artemisia scoparia",
          "Brassica campestris",
          "Cassia occidentalis",
          "Chenopodium album",
          "Chenopodium murale"
        ],
        [
          "Cyperus rotundus",
          "Dodonaea viscosa",
          "Gynandropsis gynandra",
          "Helianthus annus",
          "Parthenium hysterophorus",
          "Peltophorum pterocarpum",
          "Ricinus communis",
          "Suaeda fruticosa"
        ],
        [
          "Typha angustata",
          "Xanthium strumarium",
          "Zea mays",
          "Azadirachta indica",
          "Carica papaya",
          "Cassia siamea",
          "Cocos nucifera",
          "Eucalyptus tereticornis"
        ],
        [
          "Holoptelea integrifolia",
          "Kigelia pinnata",
          "Prosopis juliflora",
          "Putranjiva roxburghii",
          "Salvadora persica",
          "Samanea saman (albizia)",
          "Alternaria alternata",
          "Aspergillus flavus"
        ],
        [
          "Aspergillus fumigatus",
          "Aspergillus niger",
          "Aspergillus tamarii",
          "Candida albicans",
          "Cladosporium",
          "Curvularia",
          "Epicoccum",
          "Fusarium solani"
        ],
        [
          "Mucor mucedo",
          "Penicillium",
          "Rhizopus nigricans",
          "Trichoderma sp.",
          "Cotton dust",
          "Grain dust",
          "House dust",
          "Paper dust"
        ],
        [
          "Soapnut",
          "Blomia",
          "D.farinae body& feacal matter",
          "D.pteronyssinus body& feacal matter",
          "Ant",
          "American cockroach",
          "German cockroach",
          "Honey bee"
        ],
        [
          "House fly",
          "Mosquito",
          "Silkmoth",
          "Domesticmoth",
          "Buffalo dander",
          "Cat dander",
          "Cow dander",
          "Dog dander"
        ]
      ]
    };
  }
};
